import styled from "styled-components";
export const IndexResponsiveStyle = styled.div`
  @media (max-width: 1360px) {
    .header-footer {
      width: 100%;
      max-width: unset;
      padding: 0 10px 20px 10px;
      .education-item {
        width: 100%;
        max-width: unset;
      }
    }
  }

  @media (max-width: 1096px) {
    .main-wrapper {
      height: auto;
      max-height: none;
      justify-content: flex-start;
      overflow: visible;
    }
    .main {
      display: flex !important;
      flex: 0 0 auto;
      flex-direction: column;
      grid-template-columns: 1fr !important;
      gap: 14px;
      padding: 82px 14px 12px 14px;
      overflow: visible;
      .title-wrapper {
        display: flex !important;
        order: 1;
        flex: 0 0 auto;
      }
      .right-frame {
        order: 2;
        flex: 0 0 auto;
      }
      .title-icon-list {
        width: 100%;
        max-width: 425px !important;
      }
    }
    .header-footer {
      position: relative;
      grid-template-columns: 1fr !important;
      min-height: unset !important;
      flex: 0 0 auto;
      z-index: 2;
      margin-top: 0;
      .education-item {
        grid-template-columns: 120px 1fr;
      }
    }
  }
  @media screen and (max-width: 830px) {
    .title .title-english h1 {
      margin-left: -2.2rem;
    }
  }
  @media (max-width: 600px) {
    .main {
      gap: 12px;
      padding: 64px 10px 12px 10px;
      .title-wrapper {
        width: 100%;
        max-width: 100%;
        overflow: visible;
        margin: 0 auto;
        padding: 0;
      }
      .title-name {
        .title-english-1 {
          font-size: clamp(2.4rem, 15vw, 4.6rem) !important;
          line-height: 0.82 !important;
        }
        .title-english-2 {
          font-size: clamp(2.6rem, 16vw, 4.9rem) !important;
          line-height: 0.86 !important;
        }
        .title-japanese {
          font-size: clamp(1.6rem, 8vw, 3rem) !important;
          line-height: 1 !important;
        }
      }
      .title-icon-list {
        max-width: 340px !important;
        margin: 8px auto 0 auto;
        gap: 4px;
        li {
          height: 28px;
          img {
            width: 26px !important;
          }
        }
      }
      .title-frontend {
        font-size: clamp(1.6rem, 9vw, 2.7rem) !important;
        line-height: 1 !important;
      }
    }
    .right-frame {
      padding: 0;
      align-items: flex-start;
      .info-card {
        max-width: 100%;
        padding: 10px 12px;
        border-radius: 16px;
      }
      .info-row {
        gap: 4px 10px;
        padding: 7px 0;
        grid-template-columns: minmax(112px, auto) 1fr;
      }
      .info-row dt {
        font-size: 0.72rem;
        white-space: normal;
      }
      .info-row dd {
        font-size: 0.82rem;
        min-width: 0;
      }
      .languages {
        justify-content: flex-end;
      }
      .documents {
        gap: 6px;
        margin-top: 10px;
        padding-top: 10px;
      }
      .document-item {
        min-height: 36px;
        padding: 7px 10px;
        border-radius: 9px;
        font-size: 0.8rem;
      }
    }
    .header-footer {
      gap: 8px;
      padding: 0 10px 16px 10px;
      .education-item {
        height: auto;
        min-height: 70px;
        padding: 7px 8px;
        grid-template-columns: 82px 1fr;
        border-radius: 16px;
        .education-title {
          font-size: 1.05rem;
          line-height: 1.05rem;
        }
        li {
          font-size: 0.84rem;
          line-height: 1.15;
        }
        img {
          width: 5.4rem;
          &.unisul-logo {
            width: 4rem;
          }
        }
      }
    }
  }
  @media (max-width: 420px) {
    .main {
      padding-top: 70px;
      padding-left: 10px;
      padding-right: 10px;
      .title-name {
        .title-japanese {
          font-size: clamp(1.4rem, 7.6vw, 2.6rem) !important;
          line-height: 1 !important;
        }
      }
      .title-frontend {
        margin-top:8px;
        font-size: clamp(1.45rem, 8.2vw, 2.35rem) !important;
      }
      .title-icon-list li img {
        width: 28px !important;
      }
    }
    .header-footer {
      .education-item {
        grid-template-columns: 72px 1fr !important;
        gap: 8px;
      }
    }
  }
`;
